<template>
  <div class="main-content tab-content">
    <el-tabs v-model="editableTabsValue" ref="childrenDom" type="card" closable  @tab-remove="removeTab"  @tab-click="handleClick">
      <el-tab-pane
        :key="item.name"
        v-for="item in tabs"
        :label="item.title"
        :name="item.name">
      </el-tab-pane>
    </el-tabs>
    <changepwd v-if="change_pwd"></changepwd>
    <record-list v-if="record_list"></record-list>
    <order-list v-if="order_list"></order-list>
  </div>
</template>

<script>
  import utils from "../service/utils";
  import Changepwd from "./Changepwd";
  import RecordList from "./RecordList";
  import OrderList from "./OrderList";
	export default {
		name: "Tabs",
    components:{
      Changepwd:Changepwd,
      RecordList:RecordList,
      OrderList:OrderList,
    },
    data(){
		  return{
		    editableTabsValue:'1',
        tabs:[],
        heart_examine_list:false,
        change_pwd:false,
        record_list:false,
        order_list:false,
      }
    },
    created(){
		  let page_title = this.$cookies.get('page_title_ul_wf');
		  let page_url = this.$route.params.url;
      let type = {name:page_url,title:page_title};
      this.tabs.push(type);
      this.editableTabsValue = type.name;
      this.CurrentTabContent(type);
    },
    watch:{
      $route(to,from){
        let page_url = to.params.url;
        let repeat = false;
        let page_title = this.$cookies.get('page_title_ul_wf');
        let menuObj = {name:page_url,title:page_title};
        for(let i = 0; i < this.tabs.length; i++)
        {
            if (this.tabs[i].name == menuObj.name)
            {
              repeat = true;
            }
        }
        if(!repeat){
          this.tabs.push(menuObj);
        }
        this.tabs = utils.unique(this.tabs);
        this.editableTabsValue = page_url;
        this.CurrentTabContent(menuObj);
      }
    },
    methods:{
		  CurrentTabContent(item)
      {
        this.$nextTick(() => {
          for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].name == item.name) {
              this.$refs.childrenDom.currentTab = i;
            }
          }
        });
        this.change_pwd = false;
        this.record_list = false;
        this.order_list = false;
        if(item.name == 'recordList'){ //记录列表
          this.record_list = true;
        }else if(item.name == 'orderList'){ //发单列表
          this.order_list = true;
        }else{
          this.change_pwd = true;
        }

      },
      removeTab(targetName)
      {
        let tabs = this.tabs;
        let activeName = this.editableTabsValue;
        let title = '';
        let that = this;
        if (activeName == targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name == targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
                title = nextTab.title;
                let url = "/"+nextTab.name;
                that.$router.push(url);
              }else{
                that.change_pwd = false;
                that.record_list = false;
                that.order_list = false;
                that.$router.push("/home");
              }
            }
          });
        }
        this.editableTabsValue = activeName;
        this.tabs = tabs.filter(tab => tab.name !== targetName);
      },
      handleClick(tab,event)
      {
        let type = {name:tab.name,title:tab.label};
        this.CurrentTabContent(type);
        this.editableTabsValue = tab.name;
        let url = "/"+type.name;
        this.$router.push(url);
      },
    }
	}
</script>

<style scoped lang="scss">
  .tab-content{
    width: 1360px;
    margin: 0 auto;
  }
  .tab-content >>>.el-tabs{
    padding-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Tabs.vue